import CarrierSelector from '@/common/components/CarrierSelector/CarrierSelector'
import { manageCarrierServiceTypes, subscriptionPlans } from '@/common/constants'
import CarrierInfo from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/LogisticsSection/CarrierInfo/CarrierInfo'

import ManageCarrierServiceSelector from '../ManageCarrierServiceSelector/ManageCarrierServiceSelector'
import * as Styles from './styles'

const ManageCarrierService = ({
  carrier,
  carriers,
  subscriptionPlan,
  manageCarrierService,
  onCarrierChange,
  onManageCarrierServiceChange,
  errors,
  disabled,
}) => {
  const shouldShowCarrierInfo = () => {
    return manageCarrierService === manageCarrierServiceTypes.auto && carrier?.id && !carrier?.supports_modification
  }

  return (
    <Styles.CarrierServiceContainer>
      {shouldShowCarrierInfo() ? (
        <CarrierInfo name={carrier?.name} serviceName={carrier?.service_name} />
      ) : (
        <>
          {subscriptionPlan !== subscriptionPlans.basic && (
            <ManageCarrierServiceSelector
              value={manageCarrierService}
              onChange={onManageCarrierServiceChange}
              disabled={disabled}
            />
          )}
          <CarrierSelector
            value={carrier?.id || ''}
            onChange={onCarrierChange}
            carriers={carriers}
            errors={errors}
            showIcon={manageCarrierService === manageCarrierServiceTypes.auto}
            manageCarrierService={manageCarrierService}
            disabled={disabled}
          />
        </>
      )}
    </Styles.CarrierServiceContainer>
  )
}

export default ManageCarrierService
